<script>
import Multiselect from 'vue-multiselect';

export default {
  props: {
    itemId: { type: Number, required: true },
    mode: { type: String, required: true },
    repository: { type: Object, required: true },
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      workOrders: [],
      workOrder: null,
      workOrderItems: [],
      workOrderItemsStatus: 'NULL',
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        let resp = await this.repository.customREST.getWorkOrders();

        this.workOrders = resp.data.data;
      } catch (e) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }
    },
    async workOrderSelectionChanged() {
      try {
        this.workOrderItems = [];

        if (this.workOrder == null) {
          this.workOrderItemsStatus = 'NULL';
          this.$emit('work-order-selected', this.workOrder);
          return;
        }

        this.workOrderItemsStatus = 'LOADING';

        let resp = await this.repository.customREST.getWorkOrderItems(
          this.workOrder.id,
          this.itemId
        );

        this.workOrderItemsStatus = 'NULL';

        if (resp.data != null) {
          this.workOrderItems = resp.data;
        }

        this.$emit('work-order-selected', {
          ...this.workOrder,
          workOrderItems: this.workOrderItems,
        });
      } catch (e) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
        this.workOrderItemsStatus = 'ERROR';
      }
    },
    clearMultiSelect() {
      this.workOrder = null;
      this.workOrderItems = [];
      this.workOrderItemsStatus = 'NULL';
    },
  },
  computed: {
    workOrderItemsTotal() {
      if (this.workOrderItems == null) return 0;

      return this.workOrderItems.reduce(
        (n, { totalQuantity }) => n + totalQuantity,
        0
      );
    },
    workOrderItemsConsumed() {
      if (this.workOrderItems == null) return 0;

      return this.workOrderItems.reduce(
        (n, { consumedQuantity }) => n + consumedQuantity,
        0
      );
    },
    workOrderItemsReserved() {
      if (this.workOrderItems == null) return 0;

      return this.workOrderItems.reduce(
        (n, { reservedQuantity }) => n + reservedQuantity,
        0
      );
    },
    workOrderItemsToConsume() {
      return this.workOrderItemsTotal - this.workOrderItemsConsumed;
    },
    workOrderItemsToReserve() {
      return (
        this.workOrderItemsTotal -
        this.workOrderItemsConsumed -
        this.workOrderItemsReserved
      );
    },
  },
};
</script>

<template>
  <div class="work-order-items">
    <b-form-group
      class="work-orders-group"
      :label="`${$t('workOrders.workOrders')}`"
    >
      <multiselect
        class="no_overflow"
        v-model="workOrder"
        :searchable="true"
        @input="workOrderSelectionChanged"
        :options="workOrders"
        :allowEmpty="true"
        :preserveSearch="true"
        :show-labels="false"
        :show-arrow="true"
        label="name"
        track-by="id"
        :placeholder="$t('workOrders.workOrder')"
      >
        <template v-slot:noOptions>
          {{ $t('general.noResult') }}
        </template>

        <template slot="singleLabel" slot-scope="{ option }">
          <div class="flex-box">
            <div>{{ option.name }}</div>
            <div
              class="flex-push"
              style="padding-left: 10px; padding-right: 5px; cursor: pointer"
              @mousedown.prevent.stop="clearMultiSelect()"
            >
              <i class="fas fa-times text-secondary"></i>
            </div>
          </div>
        </template>
      </multiselect>
    </b-form-group>

    <div class="work-order-items-info">
      <i
        v-if="workOrderItemsStatus == 'LOADING'"
        class="bx bx-loader-alt bx-spin text-warning"
        style="font-size: 2em"
      >
      </i>
      <div v-else-if="workOrderItemsStatus == 'ERROR'" class="text-danger">
        {{ $t('errors.operationFailedTryAgain') }}
      </div>
      <div v-else-if="workOrder != null" class="text-muted">
        <small v-if="mode == 'CONSUME'" class="text-muted">
          {{
            $t('items.toConsume') + ': ' + workOrderItemsToConsume.toString()
          }}
        </small>
        <small v-else-if="mode == 'ADD'" class="text-muted">
          {{
            $t('items.toReserve') + ': ' + workOrderItemsToReserve.toString()
          }}
        </small>
      </div>
    </div>
  </div>
</template>

<style>
.no_overflow .multiselect__content-wrapper {
  max-width: 100%;
  border-top: 1px solid #e8e8e8;
}

.multiselect--active .multiselect__tags {
  border-bottom: none;
}
</style>

<style scoped>
.work-order-items {
  width: min(300px, 80vw + 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.work-orders-group {
  width: 100%;
  margin-bottom: 2px;
}

.work-order-items-info {
  height: 30px;
}

small {
  font-size: 1.2em;
}
</style>